export default __webpack_public_path__ + "static/media/peak.254dd73b.png";